module.exports = __webpack_public_path__ + "static/img/home-01.d1ae6d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/home-01.jpg
// module id = gVdl
// module chunks = 1